import { useContext } from 'react';
import { TeerContext } from '../context/TeerContext';
import { TeerContextValue } from '../types';

/**
 * Hook to access the Teer context
 */
export function useTeer(): TeerContextValue {
  const context = useContext(TeerContext);
  
  if (context === undefined) {
    throw new Error('useTeer must be used within a TeerProvider');
  }
  
  return context;
}

/**
 * Hook to access billing configuration
 */
export function useBillingConfig() {
  const { billingConfig, isLoading, error } = useTeer();
  
  return {
    billingConfig,
    isLoading,
    error,
  };
}

/**
 * Hook to access customer data
 */
export function useCustomer() {
  const { customer, isLoading, error } = useTeer();
  
  return {
    customer,
    isLoading,
    error,
  };
}

/**
 * Hook to access subscriptions
 */
export function useSubscriptions() {
  const { subscriptions, isLoading, error } = useTeer();
  
  return {
    subscriptions,
    isLoading,
    error,
  };
}

/**
 * Hook to access checkout functionality
 */
export function useCheckout() {
  const { checkout, isLoading, error } = useTeer();
  
  return {
    checkout,
    isLoading,
    error,
  };
}

/**
 * Hook to access billing portal functionality
 */
export function useBillingPortal() {
  const { billingPortal, isLoading, error } = useTeer();
  
  return {
    billingPortal,
    isLoading,
    error,
  };
}

/**
 * Hook to access usage reporting functionality
 */
export function useUsageReporting() {
  const { reportUsage, isLoading, error } = useTeer();
  
  return {
    reportUsage,
    isLoading,
    error,
  };
}
